import { iframeConfig, styleConfig } from "../config";
import { iframeHelper } from "../helper";

function initWidget({ hidden }) {
	const widget = iframeHelper.createIframe({
		src: iframeConfig.routes.widget,
		style: styleConfig.widget.closed,
		id: iframeConfig.frameId.widget,
		...iframeConfig.frameConfig.widget,
		hidden,
	});
	const notification = iframeHelper.createIframe({
		src: iframeConfig.routes.notification,
		id: iframeConfig.frameId.notification,
		...iframeConfig.frameConfig.notification,
		hidden,
	});

	return {
		widget,
		notification,
	}
}
function initFlows({ container }) {
	return {
		flow: iframeHelper.createChildIframe({
			src: iframeConfig.routes.flow,
			style: styleConfig.flow,
			id: iframeConfig.frameId.flow,
			...iframeConfig.frameConfig.flow,
			container,
		}),
	};
}

export default {
	initWidget,
	initFlows,
}
